<div class="component-viewer">
    <mat-card>
        <mat-card-header style="display: inline;">
            <div class="row w-100">
                <div class="col-6 text-start">
                    <h2 class="mb-0">Price Bands</h2>
                </div>
                <div class="col-6 text-end">
                    <button mat-raised-button (click)="createPriceBand()">Add <mat-icon>add</mat-icon></button>
                </div>
            </div>
        </mat-card-header>
        <mat-card-content>
            <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="15" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="priceBands" (filterChanged)="getPriceBands()" (filterReset)="resetFilter()">
        </gt-table>
        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        <table mat-table [dataSource]="priceBands" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
                <td mat-cell *matCellDef="let priceBand"> {{priceBand.name}} </td>
            </ng-container>
            <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="description"> Description </th>
                <td mat-cell *matCellDef="let priceBand"> {{priceBand.description}} </td>
            </ng-container>
            <ng-container matColumnDef="lastEditedDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="lastEditedDate"> Last Edited Date </th>
                <td mat-cell *matCellDef="let priceBand"> {{priceBand.lastEditedDate | date: 'MMM d, y, h:mm a'}} </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let priceBand">
                    <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionsMenu>
                        <button mat-menu-item (click)="delete(priceBand)">
                            Delete <mat-icon>delete</mat-icon>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        </mat-card-content>
    </mat-card>
</div>